export const sidebarClasses =
  'fixed inset-y-0 left-0 z-50 flex h-dvh w-72 max-w-[85vw] flex-col border-r border-border/80 bg-surface shadow-2xl transition-transform duration-300 ease-out -translate-x-full lg:static lg:z-auto lg:max-w-none lg:shadow-none lg:translate-x-0 lg:sticky lg:top-0 lg:w-60 lg:select-none lg:transition-[width] lg:duration-200 lg:ease-in-out';

export const sidebarCollapsedClasses = 'lg:w-0 lg:min-w-0 lg:overflow-hidden lg:border-r-0';

export const sidebarOpenClasses = 'translate-x-0';

export const sidebarBackdropClasses =
  'fixed inset-0 z-40 bg-content/40 dark:bg-content/30 backdrop-blur-xs transition-opacity duration-300 lg:hidden';

export const sidebarHeaderClasses =
  'flex h-14 shrink-0 items-center justify-between border-b border-border/70 px-3.5';

export const sidebarNavClasses = 'flex flex-1 flex-col gap-3 overflow-y-auto px-2 py-3';

export const sidebarSectionTitleClasses =
  'px-2.5 pt-1.5 pb-0.5 text-xs font-bold uppercase tracking-wider text-content-muted/60 select-none';

export const sidebarItemClasses =
  'group relative flex h-9 items-center gap-2.5 rounded-lg px-2.5 text-md font-medium text-content-muted transition-all duration-150 hover:bg-surface-sunken hover:text-content';

export const sidebarItemActiveClasses =
  'bg-accent-soft text-accent font-semibold hover:bg-accent-soft';

export const sidebarItemTwoLineClasses = 'h-auto min-h-9 py-1.5';

export const sidebarItemLabelClasses = 'truncate';

export const sidebarIconClasses = 'h-4 w-4 shrink-0 transition-colors';

export const sidebarBadgeClasses =
  'ml-auto inline-flex items-center text-xs font-bold px-1.5 py-0.5 rounded-full leading-none';

export const sidebarBadgePrimaryClasses = 'bg-accent-soft text-accent';

export const sidebarBadgeWarningClasses = 'bg-caution-soft text-caution';

export const sidebarFooterClasses = 'mt-auto flex flex-col gap-1 border-t border-border/70 p-2 shrink-0';
